import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

interface DialogData {

}

@Component({
  selector: 'app-new-certificates',
  templateUrl: './new-certificates.component.html',
  styleUrls: ['./new-certificates.component.scss']
})
export class NewCertificatesComponent implements OnInit {
  newCertificateForm: FormGroup;
  isNewCertificateAdded = false;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogref: MatDialogRef<NewCertificatesComponent>,
    private toastr: ToastrService
  ) { }

  ngOnInit() {

    this.newCertificateForm = this.fb.group({
      'new_certificate_name': ["", [Validators.required, Validators.minLength(3)]],
    });

  }

  cancel() {
    this.dialogref.close();
  }

  submit() {
    if (this.newCertificateForm.valid) {
      this.dialogref.close({ data: this.newCertificateForm.value })
    }
    else {
      return this.toastr.error('The certificate name is invalid, please add a valid certificate name', 'Error');
    }

  }


}
